var _clipPath, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "804.39pt",
    height: "264.11pt",
    viewBox: "0 0 804.39 264.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 30 0 L 30 -42 L 0 -42 Z M 15 -23.703125 L 4.796875 -39 L 25.203125 -39 Z M 16.796875 -21 L 27 -36.296875 L 27 -5.703125 Z M 4.796875 -3 L 15 -18.296875 L 25.203125 -3 Z M 3 -36.296875 L 13.203125 -21 L 3 -5.703125 Z M 3 -36.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.515625 -1.984375 C 4.6875 -0.546875 8.9375 0.59375 12.84375 0.59375 C 22.375 0.59375 27 -4.796875 27 -11.046875 C 27 -16.984375 23.515625 -20.28125 16.6875 -22.921875 C 11.09375 -25.078125 8.640625 -26.9375 8.640625 -30.71875 C 8.640625 -33.484375 10.734375 -36.78125 16.265625 -36.78125 C 19.921875 -36.78125 22.625 -35.578125 23.9375 -34.859375 L 25.375 -39.125 C 23.578125 -40.140625 20.578125 -41.09375 16.4375 -41.09375 C 8.578125 -41.09375 3.359375 -36.421875 3.359375 -30.125 C 3.359375 -24.421875 7.4375 -21 14.046875 -18.65625 C 19.5 -16.5625 21.65625 -14.40625 21.65625 -10.625 C 21.65625 -6.546875 18.546875 -3.71875 13.203125 -3.71875 C 9.59375 -3.71875 6.1875 -4.921875 3.84375 -6.359375 Z M 2.515625 -1.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.578125 -36 L 5.578125 -29.046875 L 1.078125 -29.046875 L 1.078125 -25.015625 L 5.578125 -25.015625 L 5.578125 -9.1875 C 5.578125 -5.765625 6.125 -3.1875 7.625 -1.625 C 8.875 -0.1875 10.859375 0.59375 13.3125 0.59375 C 15.359375 0.59375 16.984375 0.296875 18 -0.125 L 17.765625 -4.078125 C 17.09375 -3.90625 16.078125 -3.71875 14.703125 -3.71875 C 11.765625 -3.71875 10.734375 -5.765625 10.734375 -9.359375 L 10.734375 -25.015625 L 18.296875 -25.015625 L 18.296875 -29.046875 L 10.734375 -29.046875 L 10.734375 -37.375 Z M 5.578125 -36 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 16.6875 -29.703125 C 8.640625 -29.703125 2.28125 -24 2.28125 -14.28125 C 2.28125 -5.09375 8.34375 0.65625 16.203125 0.65625 C 23.21875 0.65625 30.65625 -4.015625 30.65625 -14.765625 C 30.65625 -23.640625 25.015625 -29.703125 16.6875 -29.703125 Z M 16.5625 -25.734375 C 22.796875 -25.734375 25.265625 -19.5 25.265625 -14.578125 C 25.265625 -8.046875 21.484375 -3.296875 16.4375 -3.296875 C 11.28125 -3.296875 7.625 -8.09375 7.625 -14.453125 C 7.625 -19.984375 10.3125 -25.734375 16.5625 -25.734375 Z M 16.5625 -25.734375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 24.1875 -5.046875 C 22.6875 -4.375 20.703125 -3.59375 17.703125 -3.59375 C 11.9375 -3.59375 7.625 -7.734375 7.625 -14.453125 C 7.625 -20.515625 11.21875 -25.4375 17.875 -25.4375 C 20.765625 -25.4375 22.734375 -24.78125 24 -24.0625 L 25.203125 -28.140625 C 23.765625 -28.859375 21 -29.640625 17.875 -29.640625 C 8.40625 -29.640625 2.28125 -23.15625 2.28125 -14.21875 C 2.28125 -5.34375 7.984375 0.59375 16.734375 0.59375 C 20.640625 0.59375 23.703125 -0.359375 25.078125 -1.078125 Z M 24.1875 -5.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.59375 -42.59375 L 4.375 -42.59375 L 4.375 0 L 9.59375 0 L 9.59375 -10.921875 L 12.296875 -13.921875 L 22.3125 0 L 28.734375 0 L 15.953125 -17.09375 L 27.1875 -29.046875 L 20.8125 -29.046875 L 12.296875 -19.015625 C 11.453125 -18 10.4375 -16.734375 9.71875 -15.71875 L 9.59375 -15.71875 Z M 9.59375 -42.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.375 11.875 L 9.59375 11.875 L 9.59375 -3.90625 L 9.71875 -3.90625 C 11.453125 -1.015625 14.8125 0.65625 18.65625 0.65625 C 25.5 0.65625 31.859375 -4.5 31.859375 -14.9375 C 31.859375 -23.765625 26.578125 -29.703125 19.5625 -29.703125 C 14.8125 -29.703125 11.40625 -27.59375 9.234375 -24.0625 L 9.125 -24.0625 L 8.875 -29.046875 L 4.140625 -29.046875 C 4.265625 -26.28125 4.375 -23.28125 4.375 -19.5625 Z M 9.59375 -16.796875 C 9.59375 -17.515625 9.78125 -18.296875 9.953125 -18.953125 C 10.984375 -22.921875 14.34375 -25.5 17.9375 -25.5 C 23.515625 -25.5 26.578125 -20.515625 26.578125 -14.703125 C 26.578125 -8.046875 23.34375 -3.484375 17.765625 -3.484375 C 13.984375 -3.484375 10.796875 -6 9.84375 -9.65625 C 9.71875 -10.3125 9.59375 -11.046875 9.59375 -11.8125 Z M 9.59375 -16.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.375 0 L 9.59375 0 L 9.59375 -15.484375 C 9.59375 -16.375 9.71875 -17.21875 9.84375 -17.9375 C 10.5625 -21.90625 13.203125 -24.71875 16.921875 -24.71875 C 17.640625 -24.71875 18.1875 -24.65625 18.71875 -24.546875 L 18.71875 -29.515625 C 18.234375 -29.640625 17.8125 -29.703125 17.21875 -29.703125 C 13.6875 -29.703125 10.5 -27.234375 9.1875 -23.34375 L 8.9375 -23.34375 L 8.765625 -29.046875 L 4.140625 -29.046875 C 4.3125 -26.34375 4.375 -23.40625 4.375 -19.984375 Z M 4.375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 20 0 L 20 -28 L 0 -28 Z M 10 -15.796875 L 3.203125 -26 L 16.796875 -26 Z M 11.203125 -14 L 18 -24.203125 L 18 -3.796875 Z M 3.203125 -2 L 10 -12.203125 L 16.796875 -2 Z M 2 -24.203125 L 8.796875 -14 L 2 -3.796875 Z M 2 -24.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.3125 0 L 6.3125 -11.515625 C 6.3125 -16 6.234375 -19.234375 6.046875 -22.640625 L 6.15625 -22.6875 C 7.515625 -19.765625 9.3125 -16.6875 11.203125 -13.6875 L 19.765625 0 L 23.28125 0 L 23.28125 -26.953125 L 20 -26.953125 L 20 -15.6875 C 20 -11.484375 20.078125 -8.203125 20.40625 -4.59375 L 20.3125 -4.5625 C 19.046875 -7.3125 17.484375 -10.15625 15.484375 -13.3125 L 6.84375 -26.953125 L 3.046875 -26.953125 L 3.046875 0 Z M 6.3125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.046875 -26.953125 L 3.046875 0 L 6.515625 0 L 6.515625 -12.640625 L 19.5625 -12.640625 L 19.5625 0 L 23.078125 0 L 23.078125 -26.953125 L 19.5625 -26.953125 L 19.5625 -15.6875 L 6.515625 -15.6875 L 6.515625 -26.953125 Z M 3.046875 -26.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.6875 -1.3125 C 3.125 -0.359375 5.953125 0.40625 8.5625 0.40625 C 14.921875 0.40625 18 -3.203125 18 -7.359375 C 18 -11.3125 15.6875 -13.515625 11.125 -15.28125 C 7.40625 -16.71875 5.765625 -17.953125 5.765625 -20.484375 C 5.765625 -22.3125 7.15625 -24.515625 10.84375 -24.515625 C 13.28125 -24.515625 15.078125 -23.71875 15.953125 -23.234375 L 16.921875 -26.078125 C 15.71875 -26.765625 13.71875 -27.40625 10.953125 -27.40625 C 5.71875 -27.40625 2.234375 -24.28125 2.234375 -20.078125 C 2.234375 -16.28125 4.953125 -14 9.359375 -12.4375 C 13 -11.046875 14.4375 -9.59375 14.4375 -7.078125 C 14.4375 -4.359375 12.359375 -2.484375 8.796875 -2.484375 C 6.40625 -2.484375 4.125 -3.28125 2.5625 -4.234375 Z M 1.6875 -1.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.046875 0 L 6.515625 0 L 6.515625 -12.203125 L 16.71875 -12.203125 L 16.71875 -15.078125 L 6.515625 -15.078125 L 6.515625 -24.046875 L 17.5625 -24.046875 L 17.5625 -26.953125 L 3.046875 -26.953125 Z M 3.046875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.125 -19.796875 C 5.765625 -19.796875 1.515625 -16 1.515625 -9.515625 C 1.515625 -3.40625 5.5625 0.4375 10.796875 0.4375 C 15.484375 0.4375 20.4375 -2.6875 20.4375 -9.84375 C 20.4375 -15.765625 16.6875 -19.796875 11.125 -19.796875 Z M 11.046875 -17.15625 C 15.203125 -17.15625 16.84375 -13 16.84375 -9.71875 C 16.84375 -5.359375 14.3125 -2.203125 10.953125 -2.203125 C 7.515625 -2.203125 5.078125 -5.40625 5.078125 -9.640625 C 5.078125 -13.3125 6.875 -17.15625 11.046875 -17.15625 Z M 11.046875 -17.15625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 19.125 -19.359375 L 15.59375 -19.359375 L 15.59375 -7.484375 C 15.59375 -6.84375 15.484375 -6.203125 15.28125 -5.6875 C 14.640625 -4.125 13 -2.484375 10.640625 -2.484375 C 7.4375 -2.484375 6.3125 -4.953125 6.3125 -8.640625 L 6.3125 -19.359375 L 2.796875 -19.359375 L 2.796875 -8.046875 C 2.796875 -1.234375 6.4375 0.4375 9.484375 0.4375 C 12.921875 0.4375 14.953125 -1.59375 15.875 -3.15625 L 15.953125 -3.15625 L 16.15625 0 L 19.28125 0 C 19.15625 -1.515625 19.125 -3.28125 19.125 -5.28125 Z M 19.125 -19.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.921875 0 L 6.4375 0 L 6.4375 -11.640625 C 6.4375 -12.234375 6.515625 -12.84375 6.6875 -13.28125 C 7.28125 -15.234375 9.078125 -16.875 11.40625 -16.875 C 14.71875 -16.875 15.875 -14.28125 15.875 -11.15625 L 15.875 0 L 19.40625 0 L 19.40625 -11.5625 C 19.40625 -18.203125 15.234375 -19.796875 12.5625 -19.796875 C 9.359375 -19.796875 7.125 -18 6.15625 -16.15625 L 6.078125 -16.15625 L 5.875 -19.359375 L 2.765625 -19.359375 C 2.875 -17.765625 2.921875 -16.125 2.921875 -14.125 Z M 2.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 16.125 -28.40625 L 16.125 -16.84375 L 16.046875 -16.84375 C 15.15625 -18.40625 13.15625 -19.796875 10.203125 -19.796875 C 5.484375 -19.796875 1.484375 -15.84375 1.515625 -9.40625 C 1.515625 -3.515625 5.125 0.4375 9.796875 0.4375 C 12.953125 0.4375 15.3125 -1.203125 16.40625 -3.359375 L 16.484375 -3.359375 L 16.640625 0 L 19.796875 0 C 19.6875 -1.3125 19.640625 -3.28125 19.640625 -5 L 19.640625 -28.40625 Z M 16.125 -8.125 C 16.125 -7.5625 16.078125 -7.078125 15.953125 -6.59375 C 15.3125 -3.953125 13.15625 -2.40625 10.796875 -2.40625 C 7 -2.40625 5.078125 -5.640625 5.078125 -9.5625 C 5.078125 -13.84375 7.234375 -17.046875 10.875 -17.046875 C 13.515625 -17.046875 15.4375 -15.203125 15.953125 -12.953125 C 16.078125 -12.515625 16.125 -11.921875 16.125 -11.484375 Z M 16.125 -8.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 16.84375 0 C 16.59375 -1.3125 16.515625 -2.953125 16.515625 -4.640625 L 16.515625 -11.875 C 16.515625 -15.765625 15.078125 -19.796875 9.15625 -19.796875 C 6.71875 -19.796875 4.40625 -19.125 2.796875 -18.078125 L 3.59375 -15.765625 C 4.953125 -16.640625 6.84375 -17.203125 8.640625 -17.203125 C 12.59375 -17.203125 13.046875 -14.3125 13.046875 -12.71875 L 13.046875 -12.3125 C 5.5625 -12.359375 1.40625 -9.796875 1.40625 -5.125 C 1.40625 -2.3125 3.40625 0.4375 7.3125 0.4375 C 10.078125 0.4375 12.15625 -0.921875 13.234375 -2.4375 L 13.359375 -2.4375 L 13.640625 0 Z M 13.125 -6.515625 C 13.125 -6.15625 13.046875 -5.765625 12.921875 -5.40625 C 12.359375 -3.765625 10.765625 -2.15625 8.234375 -2.15625 C 6.4375 -2.15625 4.921875 -3.234375 4.921875 -5.515625 C 4.921875 -9.28125 9.28125 -9.953125 13.125 -9.875 Z M 13.125 -6.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.71875 -24 L 3.71875 -19.359375 L 0.71875 -19.359375 L 0.71875 -16.6875 L 3.71875 -16.6875 L 3.71875 -6.125 C 3.71875 -3.84375 4.078125 -2.125 5.078125 -1.078125 C 5.921875 -0.125 7.234375 0.40625 8.875 0.40625 C 10.234375 0.40625 11.3125 0.203125 12 -0.078125 L 11.84375 -2.71875 C 11.40625 -2.59375 10.71875 -2.484375 9.796875 -2.484375 C 7.84375 -2.484375 7.15625 -3.84375 7.15625 -6.234375 L 7.15625 -16.6875 L 12.203125 -16.6875 L 12.203125 -19.359375 L 7.15625 -19.359375 L 7.15625 -24.921875 Z M 3.71875 -24 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.4375 0 L 6.4375 -19.359375 L 2.921875 -19.359375 L 2.921875 0 Z M 4.6875 -27 C 3.40625 -27 2.484375 -26.046875 2.484375 -24.796875 C 2.484375 -23.59375 3.359375 -22.640625 4.59375 -22.640625 C 6 -22.640625 6.875 -23.59375 6.84375 -24.796875 C 6.84375 -26.046875 6 -27 4.6875 -27 Z M 4.6875 -27 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.15625 0 L 11.6875 0 L 11.6875 -24 L 19.921875 -24 L 19.921875 -26.953125 L -0.046875 -26.953125 L -0.046875 -24 L 8.15625 -24 Z M 8.15625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.921875 0 L 6.40625 0 L 6.40625 -10.3125 C 6.40625 -10.921875 6.484375 -11.484375 6.5625 -11.953125 C 7.046875 -14.59375 8.796875 -16.484375 11.28125 -16.484375 C 11.765625 -16.484375 12.125 -16.4375 12.484375 -16.359375 L 12.484375 -19.6875 C 12.15625 -19.765625 11.875 -19.796875 11.484375 -19.796875 C 9.125 -19.796875 7 -18.15625 6.125 -15.5625 L 5.953125 -15.5625 L 5.84375 -19.359375 L 2.765625 -19.359375 C 2.875 -17.5625 2.921875 -15.59375 2.921875 -13.3125 Z M 2.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.5625 -0.921875 C 2.921875 -0.125 4.875 0.40625 7 0.40625 C 11.59375 0.40625 14.234375 -2 14.234375 -5.40625 C 14.234375 -8.28125 12.515625 -9.953125 9.15625 -11.234375 C 6.640625 -12.203125 5.484375 -12.921875 5.484375 -14.515625 C 5.484375 -15.953125 6.640625 -17.15625 8.71875 -17.15625 C 10.515625 -17.15625 11.921875 -16.515625 12.6875 -16.046875 L 13.5625 -18.59375 C 12.484375 -19.234375 10.765625 -19.796875 8.796875 -19.796875 C 4.640625 -19.796875 2.125 -17.234375 2.125 -14.125 C 2.125 -11.796875 3.765625 -9.875 7.234375 -8.640625 C 9.84375 -7.6875 10.84375 -6.765625 10.84375 -5.078125 C 10.84375 -3.484375 9.640625 -2.203125 7.078125 -2.203125 C 5.3125 -2.203125 3.484375 -2.921875 2.4375 -3.59375 Z M 1.5625 -0.921875 "
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 593 0 L 804.390625 0 L 804.390625 86 L 593 86 Z M 593 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 595.65625 81.589844 L 798.933594 81.589844 L 798.933594 2.898438 L 595.65625 2.898438 L 595.65625 81.589844 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    },
    d: "M 804.386719 -0.00390625 L 593.207031 -0.00390625 L 593.207031 85.035156 L 804.386719 85.035156 Z M 678.113281 8.199219 L 663.535156 76.648438 L 640.65625 76.648438 L 626.273438 29.285156 L 626.082031 29.285156 L 616.511719 76.648438 L 599.164063 76.648438 L 613.859375 8.199219 L 636.8125 8.199219 L 650.914063 55.664063 L 651.105469 55.664063 L 660.765625 8.199219 Z M 743.550781 8.199219 L 729.257813 76.648438 L 710.832031 76.648438 L 716.941406 47.332031 L 695.152344 47.332031 L 689.042969 76.648438 L 670.617188 76.648438 L 684.914063 8.199219 L 703.335938 8.199219 L 697.925781 34.386719 L 719.703125 34.386719 L 725.125 8.199219 Z M 796.476563 10.066406 L 792.035156 23.695313 C 788.488281 22.035156 783.660156 20.566406 776.863281 20.566406 C 769.574219 20.566406 763.65625 21.636719 763.65625 27.136719 C 763.65625 36.835938 790.367188 33.214844 790.367188 54.003906 C 790.367188 72.925781 772.71875 77.835938 756.753906 77.835938 C 749.660156 77.835938 741.476563 76.160156 735.472656 74.292969 L 739.808594 60.367188 C 743.445313 62.726563 750.75 64.296875 756.753906 64.296875 C 762.480469 64.296875 771.4375 63.214844 771.4375 56.15625 C 771.4375 45.167969 744.726563 49.289063 744.726563 29.980469 C 744.726563 12.320313 760.304688 7.027344 775.386719 7.027344 C 783.867188 7.027344 791.84375 7.917969 796.476563 10.066406 "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 558.51,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 587.91041,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 607.41041,
    y: 150.094
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 640.35041,
    y: 150.094
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 667.23041,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 696.389648,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 730.52833,
    y: 150.094
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 763.46833,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 784.527928,
    y: 150.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 441.791,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 468.110268,
    y: 200.094
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 494.190268,
    y: 200.094
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 513.910268,
    y: 200.094
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 522.390268,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 540.6315,
    y: 200.094
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 562.5915,
    y: 200.094
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 584.6315,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-9",
    x: 606.830669,
    y: 200.094
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 629.390669,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 648.510806,
    y: 200.094
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 661.750806,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 671.110172,
    y: 200.094
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 693.070172,
    y: 200.094
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 715.270172,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 722.110036,
    y: 200.094
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,44.699097%,73.699951%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-14",
    x: 740.190132,
    y: 200.094
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 753.270132,
    y: 200.094
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 775.310132,
    y: 200.094
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 791.150132,
    y: 200.094
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.d2d5998fcb8b95ee70543442c468303f.svg";
export { ForwardRef as ReactComponent };